import React from "react";
import { m as motion } from "../../shared/components/Motion";
import { LayoutGroup } from "framer-motion";
import "./styles/SegmentedControl.css";

const SegmentedControl = ({
  options,
  selected,
  onChange,
  label,
  layoutId = "segmented-control-background",
}) => {
  return (
    <LayoutGroup id={layoutId}>
      <div className="segmented-control">
        {options.map((option) => (
          <button
            key={option.value}
            className={`segmented-control-option  ${
              selected === option.value ? "active" : ""
            }`}
            onClick={() => onChange(option.value)}
            type="button"
            title={option.title || undefined}
          >
            {selected === option.value && (
              <motion.div
                className="segmented-control-background"
                layoutId={layoutId}
                transition={{
                  type: "spring",
                  stiffness: 500,
                  damping: 30,
                }}
              />
            )}
            <span className="segmented-control-text">{option.label}</span>
            {option.subtitle && (
              <span className="segmented-control-subtitle">
                {option.subtitle}
              </span>
            )}
          </button>
        ))}
      </div>
    </LayoutGroup>
  );
};

export default SegmentedControl;
